var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/LessThan
 */
import ComparisonBinary from './ComparisonBinary.js';
/**
 * @classdesc
 * Represents a `<PropertyIsLessThan>` comparison operator.
 * @api
 */
var LessThan = /** @class */ (function (_super) {
    __extends(LessThan, _super);
    /**
     * @param {!string} propertyName Name of the context property to compare.
     * @param {!number} expression The value to compare.
     */
    function LessThan(propertyName, expression) {
        return _super.call(this, 'PropertyIsLessThan', propertyName, expression) || this;
    }
    return LessThan;
}(ComparisonBinary));
export default LessThan;
//# sourceMappingURL=LessThan.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ol/format/filter/LessThan.js
// module id = 514
// module chunks = 1